import React, {useState} from 'react'
import {LoadEffect, TableLoader}  from '../component/loader'
import axios from 'axios'
import {Alerts} from '../component/notify'
import PageHeader from '../component/pageheader'
import {API_URL, Currency, FormatNumber, config, userCode} from '../../component/include'
import Select from 'react-select'

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { longDate } from '../component/globalFunction'

const BookIssueReport =()=> {
    const [errors, setErrors] = useState({});
    
    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    });

   
    const [bookIssued, setBookIssued]= useState([])
    const [list, setList] = useState({
        dataType:[],
        from:'',
        to:'',
        returnDate:''
    })
    



    const handleSelect = (option, action)=>{
        setList({...list, [action.name]: option});
        setErrors({...errors, [action.name]:''})
         }
  
         const handleChange = event =>{
           const {name, value} = event.target
           setList({...list, [name]: value});
           setErrors({...errors, [name]:''})
       }



const fetchBookIssueReport =()=>{
             

        setNotice({...notice, 
            isLoading: true
        });

let sql = "Select b.bookName, b.authorName, s.studentName, i.bookCode, i.fine, i.userType, s.admissionNumber, s.mobile, i.ID, i.code,  i.dateIssue, i.issuedCount, i.dateReturn, i.userCode,   i.remarks,   i.returnedDate, i.returnStatus from tbl_book_issued i, tbl_students s, tbl_books b where i.bookCode = b.code and i.userCode = s.code and i.usertype='Student' and i.userCode ='"+userCode+"' "



if(list.dataType.length !==0 ){
      sql = sql + " and i.returnStatus ='"+list.dataType.value+"'"
  }


  if(list.from !== '' && list.to !== ''){
    sql = sql + " and i.dateIssue BETWEEN '"+list.from+"' and '"+list.to+"'"
}

const fd = new FormData();
fd.append("sql", sql);
    let url = API_URL+'/exam/result/fetch_raw'
axios.post(url, fd, config).then(result=>{ 
  if(result.data.data.length!==0){
    setBookIssued(result.data.data)
    
window.scrollTo(0,document.body.scrollHeight);
  }else{
    
Alerts('Info!', 'info', 'There are no books found under your name')
  }
    

})
.catch((error)=>{
Alerts('Error!', 'danger', error.message)
}).finally(()=>{
  
  setNotice({...notice, 
    isLoading: false
});
})

    

}

   
	
let i =1;
const tableHeader = [
{dataField: 'code', text: 'SNo', footer:'SNo', formatter:()=>i++, csvExport: false},
        {dataField: 'studentName', footer:'Issued To', text: 'Issued To', formatter: (cell, row)=>`(${row.admissionNumber}) ${cell}  `},
        {dataField: 'bookName', text: 'Books', footer:'Book', editable:false, formatter: (cell, row)=>row.returnStatus==='Yes'?<div style={{display:'block',  width:400, whiteSpace:'normal', wordWrap:'break-word' }}>{`${cell} (${row.authorName}) `}<br/><span className="pcoded-badge label label-success">Returned on {longDate(row.returnedDate)}</span></div>: <div  style={{display:'block',  width:400, whiteSpace:'normal', wordWrap:'break-word' }}>{cell} ({row.authorName}) </div>},       
        {dataField: 'dateIssue', text: 'Date of Issue', footer:'Date of Issue', formatter:(cell,row)=>
        longDate(cell)},
    {dataField: 'dateReturn', text: 'Date to Return', footer:'Date to Return',  formatter:(cell,row)=>
    longDate(cell)}, 
    {dataField: 'fine', text: 'Fine', formatter:(cell,row)=>Currency+FormatNumber(cell), footer:columnData => Currency+FormatNumber(columnData.reduce((acc, item) => Number(acc) + Number(item), 0))}
 ];
 

 
 const BookTable=(props)=>{

    const CustomToggleList = ({
        columns,
        onColumnToggle,
        toggles
      }) => ( 
      <div  className="btn-group btn-group-toggle btn-group-vertical" data-toggle="buttons">
          {
            columns
              .map(column => ({
                ...column,
                toggle: toggles[column.dataField]
              }))
              .map(column => (
                
                <button
                  type="button"
                  key={ column.dataField }
                  className={ ` btn btn-primary ${column.toggle ? 'active' : ''}` }
                  data-toggle="button"
                  aria-pressed={ column.toggle ? 'true' : 'false' }
                  onClick={ () => onColumnToggle(column.dataField) }
                >
                  { column.text }
                </button>
              ))
          }
        </div>
        
      );

    
     const { SearchBar } = Search;
 
     const customTotal = (from, to, size) => (
        <span >&nbsp;Showing { from } to { to } of { size } items</span>
      );
     const options = {
         showTotal: true,
     paginationTotalRenderer: customTotal,
     sizePerPageList: [{text: '100', value: 100}, {text: '200', value: 200}, {text: '500', value: 500},
     { text: 'All', value: props.data.length }]
        
       };
  
     return <ToolkitProvider search columnToggle 
                 keyField='ID' data={ props.data } columns={ props.columns } >
                     
                     {
                         props => (
                         <div >
                           <div className="form-group">
                             <SearchBar
                             { ...props.searchProps } style={{height:'40px'}} className="form-control" placeholder="Type to search!!!" />
                             &nbsp;
                           
                             <div className="btn-group dropdown-split-success">
  
  <button type="button" className="btn btn-primary dropdown-toggle dropdown-toggle-split waves-effect waves-light" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
  <i className="fa fa-search-plus"></i> Columns
  </button>
  
  <div className="dropdown-menu" x-placement="bottom-start" style={{overflow:'scroll', height:'260px', width:'250px', position: 'absolute', transform: 'translate3d(113px, 40px, 0px)', top: '0px', left: '0px', willChange: 'transform'}}>
    <CustomToggleList { ...props.columnToggleProps } />
  </div>
  </div>

  
                             </div>
                             
                      
             
                             <BootstrapTable
                             { ...props.baseProps }
                                         striped
                                     hover
                                     condensed
                                     noDataIndication={<div className="alert alert-danger background-danger">No Record Found</div>}
                                 pagination={paginationFactory(options) }
                                 
                             />
                         </div>
                         )
                     }
  </ToolkitProvider>
  }




        return (  
            <React.Fragment>{notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
   <div  className="main-body">
                <div className="page-wrapper">
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title="Library">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-book"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><a href="/library/books">Library</a> </li>
                    <li className="breadcrumb-item"><a href="#!">Books Issue Report</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">
               
                <div className="row  ">
							

	<div className="col-sm-12">
    <div className="card z-depth-0">
		<div className="card-header">
			<h5><i className="fa fa-edit" ></i>  Search</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-maximize full-card"></i></li>
					<li><i className="feather icon-minus minimize-card"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div><div className="card-block">
        <div className="card z-depth-0">
		<div className="card-block">
		
        
        <div className="row">
								
            <section className="col-md-4">

            <div className="form-group">
						<label >Type</label>
                        <Select  options={[
                    { value: 'Yes', label: 'Already Returned' },
                    { value: 'No', label: 'Not Yet Return' },
                ]} 
        onChange={handleSelect}  name="dataType" value={list.dataType}  /> 
			</div>
</section>

<section className="col-md-4">
<div className="form-group">
						<label >From Date</label>
		<input type="date" name="from" className='form-control'   value={list.from}  onChange={handleChange}  /> 
			</div>
</section>


<section className="col-md-4">
<div className="form-group">
						<label >To Date</label>
		
                        <input type="date" name="to" className='form-control'  value={list.to}  onChange={handleChange}  /> 	
			</div>
</section>


</div>

	<footer className="pull-right">
	<button type="button" id="submit" onClick={fetchBookIssueReport} className="btn btn-inverse "><i className="fa fa-search"></i> Proceed</button>
								</footer>				
							</div>
                            </div>
							</div>
                            </div>   

</div></div>
	
{bookIssued.length!==0?
<div className="row  ">   <div className="col-sm-12">
                               
                                                
<div className="card z-depth-0">
            <div className="card-header">
                <h5><i className="fa fa-th" ></i> Listing All Books</h5>
                <div className="card-header-right">
                    <ul className="list-unstyled card-option">
                        <li><i className="feather icon-maximizes full-card"></i></li>
                        <li><i className="feather icon-minus minimize-card"></i></li>
                        <li><i className="feather icon-trash-2 close-card"></i></li>
                    </ul>
                </div>
            </div>
            <div className="card-block">
            <div className="col-md-12 table-responsive">

         {notice.isDataFetching ? <TableLoader />:
         <BookTable data={bookIssued}  columns={tableHeader}  /> 
        } 

            </div></div></div>

    
    </div>
    </div>:''}




   </div>
          {/* The Page Body close here */}

            </div>
            </div>

</React.Fragment>
 );
        
}

export default React.memo(BookIssueReport) 